import { put, race, take } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { closeDialog } from '../../../../../services/dialog/actions'
import { error } from '../../../../../services/toastr'

import {
    changeEntityStackTab,
    swChangeEntityStackTab,
} from '../../../../../scenes/Gnosus/components/EntityStack/actions'

import { createNewGroup } from '../../../../../scenes/Gnosus/components/GroupStack/actions'
import { CREATE_GROUP_REQUEST } from '../../../../../scenes/Gnosus/components/GroupStack/constants'

import { LOCALE_PREFIX } from '../constants'
import { manageGroupsDialogImport } from '../actions'

const CREATE_GROUP_REQUEST_SUCCESS = `${CREATE_GROUP_REQUEST}_${SUCCESS}`
const CREATE_GROUP_REQUEST_FAILED = `${CREATE_GROUP_REQUEST}_${FAILED}`

export default function* dialogCreateNewGroupCallSaga(action) {
    const dialogType = _.get(action, 'data.dialog.type', null)
    const dialogId = _.get(action, 'data.dialog.id', null)
    const entities = _.get(action, 'data.entities', null)

    if (!dialogType || !dialogId) {
        error({ id: `${LOCALE_PREFIX}.createNewGroupError` })
        return null
    }

    yield put(closeDialog(dialogType, dialogId))

    yield put(changeEntityStackTab('groups'))
    yield put(swChangeEntityStackTab('groups'))

    yield put(createNewGroup())
    const createGroupResult = yield race({
        success: take(CREATE_GROUP_REQUEST_SUCCESS),
        failed: take(CREATE_GROUP_REQUEST_FAILED),
    })

    if (!createGroupResult.failed) {
        const groupId = _.get(createGroupResult, 'success.payload.response.body.id', null)

        yield put(manageGroupsDialogImport(groupId, entities, -1, true))
    } else {
        error({ id: `${LOCALE_PREFIX}.createNewGroupError` })
        return null
    }

    return null
}
